export default "__VITE_ASSET__f75c6018__"